import { Title } from '@angular/platform-browser';
import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, QueryList, signal } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { Service, ServicesPTreeSelect } from 'src/app/shared/models/iCourrier/service';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { Source } from 'src/app/shared/models/iCourrier/source';
import { UserService } from 'src/app/shared/models/iCourrier/me/user-service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ErrorService } from 'src/app/shared/services/error.service';
import { HttpErrorModalComponent } from 'src/app/components/modals/http-error-modal/http-error-modal.component';
import { catchError, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { SplitAreaDirective } from 'angular-split';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { ActionCreateModalComponent } from '../../ACTIONS/action-create-modal/action-create-modal.component';
import { EMailFileDetails } from 'src/app/shared/models/iCourrier/email/email-file-details';
import { DataService } from 'src/app/shared/services/data.service';
import * as async from 'async';
import * as _ from 'underscore';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { CModeChoiceModalComponent } from 'src/app/components/modals/c-mode-choice-modal/c-mode-choice-modal.component';
import { ConfirmationService } from 'primeng/api';
import { RecipientModalComponent } from '../../COURRIER-S/recipient-modal/recipient-modal.component';
import { GuardConfirmModalComponent } from 'src/app/components/modals/guard-confirm-modal/guard-confirm-modal.component';
import { PrendreEnChargeModalComponent } from '../prendre-en-charge-modal/prendre-en-charge-modal.component';
import { ParamsService } from 'src/app/shared/services/params.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DialogService } from 'primeng/dynamicdialog';
import { DuplicateModalsComponent } from 'src/app/components/modals/duplicate-modals/duplicate-modals.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { MeRightsPointsSeancesDTO, UserContact } from 'src/app/shared/models';
import { WorkflowsService } from 'src/app/shared/services/workflows.service';
import { TranslateService } from '@devinforius/i-essentials';
import { IDelibeService } from 'src/app/shared/services/i-delibe.service';
import { CreateNewTagComponent } from 'src/app/components/modals/create-new-tag/create-new-tag.component';
import { WorkflowsRightMails } from 'src/app/shared/models/workflows/right-mails';
import { RightManagement } from 'src/app/shared/models/iCourrier/right/right-management';
import { Bacs, BacsDTO } from 'src/app/shared/models/workflows/bacs';
import { ServicesService } from 'src/app/shared/services/services.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { UserDto, UserInfosDto } from 'src/app/shared/interfaces/users';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import {
  ContactDto,
  DropdownNature,
  DropdownRole,
  DropdownService,
  DropdownSource,
  LowInformationsDTO,
  MailCreatedDTO,
  MailFileDto,
  MailRightsDto,
  NatureDto,
  ServiceDto,
  SourceDto,
  VatDto,
} from 'src/app/shared/interfaces';
import { MyOwnServiceDto } from 'src/app/shared/interfaces/services/my-own-service-dto.interface';
import { MailsService } from 'src/app/shared/services/mails.service';
import { NaturesService } from 'src/app/shared/services/natures.service';
import { DocumentStatusDto } from 'src/app/shared/interfaces/documents/document-status-dto.interface';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { SourcesService } from 'src/app/shared/services/sources.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfigDto } from 'src/app/shared/interfaces/config';
import { VatsService } from 'src/app/shared/services/vats.service';
import { AssetsCalendarFr } from 'src/app/shared/models/calendar-fr';
import { RolesService } from 'src/app/shared/services/roles.service';
import { MeService } from 'src/app/shared/services/me.service';
import { MeRightMailMails } from 'src/app/shared/models/iCourrier/me/right-mail-global';
import { iAdminService } from 'src/app/shared/services/i-admin.service';
import { WorkflowInstance, WorkflowInstanceDTO } from 'src/app/shared/models/workflows/workflow-instance';
import { GlobalCentreNumerisationDTO } from 'src/app/shared/models/iCourrier/centre-numerisation/global-centre-numerisation';
import { MultipleStatutesService } from 'src/app/shared/services/multiple-statutes.service';
import {
  MailMultipleStatutes,
  MailMultipleStatutesDTO,
  MultipleStatutes,
  MultipleStatutesDTO,
} from 'src/app/shared/models/iCourrier/status-management/multiple-statutes';
import { ActionsService } from 'src/app/shared/services/actions.service';
import { RecipientsService } from 'src/app/shared/services/recipients.service';
import { MeRightMail } from 'src/app/shared/models/iCourrier/me/right-mail-id';
import { FilesService } from 'src/app/shared/services/files.service';
import { MailsRightsService } from 'src/app/shared/services/mails-rights.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Mail, MailInfosViaExtraStateRouter } from 'src/app/shared/models/mails/mail';
import { MailFileVersionDisplayedDropdown } from 'src/app/shared/models/mails/mail-file';
import { MailDestinataire } from 'src/app/shared/models/mails/mail-destinataire';
import { MailCountsDTO, MailDTO, MailFullInfosDTO } from 'src/app/shared/interfaces/mails/mail-dto.interface';
import { GroupsService } from 'src/app/shared/services/groups.service';
import { GroupsMembersDTO } from 'src/app/shared/interfaces/groups/groups-members.interface';
import { BadRouting } from 'src/app/shared/models/mails/bad-routing';
import { MailsTakeChargeService } from 'src/app/shared/services/mails-take-charge.service';
import { NumerisationCentersService } from 'src/app/shared/services/numerisation_centers.service';
import { MailsLockUnlockService } from 'src/app/shared/services/mails-lock-unlock.service';
import { MailLockEntry } from 'src/app/shared/models/mails/mails-lock';
import { MailLockEntryDTO } from 'src/app/shared/interfaces/mails/mails-lock-dto.interface';
import { MailDetails } from 'src/app/shared/models/mails/mail-details-dto.';
import { RecipientModalOnCloseDatas } from 'src/app/shared/models/recipient-modal';
import { ContactsRemplacantDTO } from 'src/app/shared/models/iContact/contact/remplacant';
import { environment } from 'src/environments/environment';
import { AreaDropEvent, DroppableArea } from '@devinforius/i-essentials/lib/interfaces';
import { Cols } from 'src/app/shared/models/cols';
import { ITab } from '@devinforius/i-navigation/lib/models/i-tabsXl';
import { manageServicesSetAsTreeSelect, manageServicesToBeMerged } from 'src/app/shared/utils/manage-services-for-tree-select.utils';
import { OverlayPanel } from 'primeng/overlaypanel';

export class TabInterface {
  header: string;
  slug: string;
  active: boolean;
  count?: number;
  icon: string;
}

@Component({
  selector: 'app-courrier-fiche-form',
  templateUrl: './courrier-fiche-form.component.html',
  styleUrls: ['./courrier-fiche-form.component.scss'],
})
export class CourrierFicheFormComponent implements OnInit {
  @ViewChildren(SplitAreaDirective) areasEl: QueryList<SplitAreaDirective>;

  public panelSize = [30, 70];
  public collapsedState: 'left' | 'middle' = 'middle';

  public courrierTitle;
  public tabsArrayXL: ITab[] = [
    { label: 'infos', id: 'infos', icon: 'courrier_tabs_info' },
    { label: 'files', id: 'files', count: 0, icon: 'courrier_tabs_fichiers' },
    { label: 'mailTracking', id: 'recipients', count: 0, icon: 'courrier_tabs_suivi' },
    { label: 'links', id: 'links', icon: 'courrier_tabs_liens' },
    { label: 'historique', id: 'historic', icon: 'courrier_tabs_historique' },
  ];
  public mailTabActiveXL = 'infos';
  public actionModal = false;
  public uploadedFilesFromDragAndDrop: File[] = [];
  public isFileOverComponent = false;

  public listOfUsers: UserContact[] = [];
  public clientType: string = sessionStorage.getItem('clientType');

  public filesAreHidden = false;

  public forceSwitchFile: number[] = [];

  @Input() public mailId: number; // if mailId => no route params because we are in a modal

  @Output() public enableFlowActions = new EventEmitter<boolean>();

  public serviceList: ServicesPTreeSelect[] = [];
  public natureList: NatureDto[] = [];
  public sourceList: Source[] = [];
  public statutList: DocumentStatusDto[] = [];
  public courrier: MailDetails;
  public userServices: MyOwnServiceDto[];
  public selectedUserService: UserService; // the service configuration for the serviceProprietaire selected
  public selectedService: Service; // the serviceProprietaire selected
  public userInfos: UserInfosDto; // Access of the connected user
  public configuration: ConfigDto;
  public locale4Calendar: AssetsCalendarFr; // locale for calendar
  public isCourrier: boolean; // if false other tags are not available
  public files: MailFileDto[];
  public foundServiceRight: MeRightMailMails;
  public isFormDisabled: boolean;
  public participants: Array<MailDestinataire> = [];
  public contacts: Array<ContactDto> = [];
  private ngUnsubscribe = new Subject(); // For errors messages
  public typeEntrantSortant: string;
  public natureListLV: DropdownNature[] = [];
  // Email Parsing
  public convertedMail: EMailFileDetails;
  public currentMail: Mail;
  public supported = false; // for button 'prendre en charge' and 'pris en charge'
  public signatureSended: boolean;
  public participantPrincipal: MailDestinataire;
  // SuperParticipants
  public participantsLimit = 2;
  public participantsMaxToolTip = 10;
  public sourceListLV: DropdownSource[] = [];
  public statutListLV: { label: string; value: number }[] = [];
  public today = new Date();
  public form = this.formBuilder.group({
    typeEntrantSortant: new UntypedFormControl('E'),
    confidentiel: new UntypedFormControl(false),
    objet: new UntypedFormControl('', Validators.maxLength(4000)),
    dateEntree: new UntypedFormControl(new Date()),
    dateDocument: new UntypedFormControl(null),
    dateEcheance: new UntypedFormControl(null),
    datePostale: new UntypedFormControl(null),
    link: new UntypedFormControl(''),
    avalider: new UntypedFormControl(null),
    serviceProprietaireId: new UntypedFormControl(null, Validators.required),
    expediteurId: new UntypedFormControl(null),
    expediteurIdiAdmin: new UntypedFormControl(null),
    expediteurLibre: new UntypedFormControl(''),
    refExpediteur: new UntypedFormControl(''),
    natureId: new UntypedFormControl(null),
    sourceId: new UntypedFormControl(null),
    statutId: new UntypedFormControl(null),
    remarques: new UntypedFormControl(''),
    classementId: new UntypedFormControl(null),
    chemiseId: new UntypedFormControl(null),
    classeurId: new UntypedFormControl(null),
    enableExpFree: new UntypedFormControl(null),
    referenceRecommande: new UntypedFormControl(null),
  });
  public formMauvaisRoutage = new UntypedFormGroup({
    commentaires: new UntypedFormControl(null, [Validators.required, Validators.pattern(/\S/)]),
  })
  public tempArray = [];
  public multiSelectSettings = {
    singleSelection: true,
    text: 'Selectionner un service',
    selectAllText: 'Tout Sélectionner',
    unSelectAllText: 'Déselectionner tout',
    searchPlaceholderText: 'Rechercher un service',
    enableSearchFilter: true,
    badgeShowLimit: 5,
    groupBy: 'parentId',
  };
  public displayModalTree = false;
  public selectedOption: ServicesPTreeSelect;
  public enableExpFree = false;
  public services: ServiceDto[] = [];
  public statutGlobal: DocumentStatusDto[] = [];
  public statutGlobalLV: { label: string; value: number; color: string; background: string; ordre: number }[] = [];
  public showStatusDropdown = false;
  public tagsCourrier: MailMultipleStatutes[] = [];
  public tags: MultipleStatutes[] = [];
  public colTags: Cols[] = [
    {
      field: 'description',
      header: 'Description',
      sortable: true,
      format: (_value, item) => {
        if (item.etiquette && item.etiquette.description) {
          return item.etiquette.description;
        } else {
          return '';
        }
      },
    },
  ];
  public rightMail: MeRightMail = null;
  public fileToShow: MailFileVersionDisplayedDropdown = null;
  public fluxActionsButtons = [
    {
      text: 'Demander des actions',
      styleClass: 'blue',
      id: 'fluxBtnActionCreate',
      disabled: false,
      tooltip: 'Demander des actions',
      click: () => {
        this.createAction();
      },
    },
  ];

  public servicesChildParent: {
    label: string;
    value: number;
    parentId: number;
    id: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
  }[] = [];
  public mauvais_routage: BadRouting;
  public openMauvaisRoutage = false;
  public hideID: number = null;
  public rolesLV: Array<DropdownRole> = [];
  public showDuplicateDialog = false;
  public formDuplicate = this.formBuilder.group({
    data: new UntypedFormControl(false),
    classements: new UntypedFormControl(false),
    files: new UntypedFormControl(false),
    destinataires: new UntypedFormControl(false),
    links: new UntypedFormControl(false),
  });
  public rightMailsGlobal: MailRightsDto;
  public rightManagement: RightManagement;
  public columnsAcces: Cols[] = [
    {
      field: 'contactName',
      header: 'Utilisateur',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'lockMode',
      header: 'Accès',
      format: (value) => {
        if (value === 'Write') {
          return 'Ecriture';
        } else {
          return 'Lecture';
        }
      },
    },
    {
      field: 'date',
      header: 'Date',
      format: (value) => {
        if (value) {
          return moment(value).format('DD/MM/YYYY à HH:mm');
        } else {
          return '/';
        }
      },
      sort: (a, b, order) => {
        const val1 = moment(a, 'DD/MM/YYYY à HH:mm').isValid() ? moment(a, 'DD/MM/YYYY à HH:mm').unix() : null;
        const val2 = moment(b, 'DD/MM/YYYY à HH:mm').isValid() ? moment(b, 'DD/MM/YYYY à HH:mm').unix() : null;
        if (val1 === null) return 1;
        else if (val2 === null) return -1;
        else return val1 < val2 ? 1 * order : -1 * order;
      },
      sortable: true,
    },
  ];
  public locksInfo: MailLockEntry[] = [];
  public currentUserLockInfo: MailLockEntryDTO = null;
  public openSidebarIBac = false;
  public bacs: Bacs[] = [];
  public currentBac: Bacs;
  public rightFlux: WorkflowsRightMails;

  public config = environment;
  public rightsDelibe: boolean;
  public listToReloadDatas;
  public userToReaffectTo = null;
  public amountOfFiles = 0;
  public numerisations_center = [];

  public errorDisplayed = '';
  public groupsMemberUserConnected: GroupsMembersDTO[] = [];
  public droppableAreas = signal<DroppableArea[]>([
    {
      identifier: 1,
      text: 'courrierFiche.dropFileToAdd',
    },
  ]);

  public listOfVersion: MailFileVersionDisplayedDropdown[] = [];
  public isAnotherVersionThanVersionOfFile: boolean = false;
  public currentFile: MailFileDto = null;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private contactService: ContactsService,
    private errorService: ErrorService,
    private translationService: TranslationService,
    private dataService: DataService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    public confirmService: ConfirmationService,
    private dialogService: DialogService,
    private router: Router,
    public titleService: Title,
    public params: ParamsService,
    public spinner: NgxSpinnerService,
    public workflows: WorkflowsService,
    public translater: TranslateService,
    private servicesService: ServicesService,
    private usersService: UsersService,
    private contactsService: ContactsService,
    private mailsService: MailsService,
    private naturesService: NaturesService,
    private documentsService: DocumentsService,
    private sourcesService: SourcesService,
    private configService: ConfigService,
    private vatsService: VatsService,
    private iDelibeService: IDelibeService,
    private rolesService: RolesService,
    private meService: MeService,
    private iAdminService: iAdminService,
    private multipleStatutesService: MultipleStatutesService,
    private actionsService: ActionsService,
    private recipientsService: RecipientsService,
    private filesService: FilesService,
    private mailsRightsService: MailsRightsService,
    private groupsService: GroupsService,
    private mailsTakeChargeService: MailsTakeChargeService,
    private numerisationCentersService: NumerisationCentersService,
    private mailsLockUnlockService: MailsLockUnlockService
  ) {
    this.initializeErrors();
  }

  ngOnInit(): void {
    this.spinner.show();
    this.setTranslations();
    this.hideID = null;
    this.route.paramMap.subscribe({
      next: (paramURL) => {
        this.errorDisplayed = '';
        const id: number = parseFloat(paramURL.get('id'));
        this.initData(id ?? this.mailId);
      },
    });
  }

  private setTranslations(): void {
    this.tabsArrayXL.map((element) => {
      element.label = this.translater.translate(element.label);
    });
    this.droppableAreas.update((areas) => [...areas.map((area) => ({ ...area, text: this.translater.translate(area.text) }))]);
  }

  initData(mailId: number): void {
    this.mailsService
      .fetchMailDetails(mailId)
      .pipe(
        tap((res: MailFullInfosDTO) => {
          this.courrier = new MailDetails(res);
          this.mailId = res.id;
          this.mailsService.setCanAccessToMail(mailId);
          this.titleService.setTitle(this.translater.translate('tabsTitle.id', { id: this.courrier.id }));
          sessionStorage.setItem('courrierID', this.courrier.id.toString());

          if (this.courrier.expediteurLibre) {
            this.enableExpFree = true;
          } else {
            this.enableExpFree = false;
          }

          this.statutGlobal = [];
          this.statutGlobalLV = [];
          this.fileToShow = null;
        }),
        switchMap((mail) => {
          return forkJoin({
            rightManagement: this.meService.rightManagement(),
            writeLockContact: mail.writeLockId ? this.contactsService.fetchContact(mail.writeLock.contactId, 'iAdmin') : of(null),
            mailRights: this.mailsRightsService.fetchGlobalMailRights(),
            services: this.servicesService.fetchMappedServicesToPrimeNGDropdowns(),
            allNatures: this.naturesService.fetchNatures(),
            documentsStatutes: this.documentsService.fetchDocumentsStatutes(),
            allSources: this.sourcesService.fetchSources(),
            userInfos: this.usersService.fetchUserInfosiCourrier(),
            configuration: this.configService.fetchConfig(),
            myServices: this.meService.fetchMyOwnServices(),
            calendarTranslations: this.translationService.getCalendartranslate('fr'),
            lockInfos: this.mailsLockUnlockService.getLockInfo(mail.id),
            roles: this.rolesService.getRolesMappedToPrimeNGDropdowns(),
            participants: this.recipientsService.getMailsDestinataires(mail.id),
            multipleStatutes: this.multipleStatutesService.getMultipleStatus(),
            mutlipleStatutesForThisMail: this.multipleStatutesService.getMailMultipleStatutes(mail.id),
            userContacts: this.usersService
              .fetchUsersFromiAdmin({ Active: true })
              .pipe(map((res: UserDto[]) => res.map((user: UserDto) => new UserContact(user)))),
            validationUsers: mail.validationEtapeUserIds
              ? this.usersService.fetchUsersFromiAdmin({ UserIds: `${mail.validationEtapeUserIds}` }).pipe(
                map((res: UserDto[]) => {
                  return res
                    .filter(Boolean)
                    .map((user: UserDto) => `${user.contactForUser.prenom ? user.contactForUser.prenom + ' ' : ''}${user.contactForUser.nom}`)
                    .join(' ou ');
                })
              )
              : of(''),
            rightsForThisMail: this.mailsRightsService.getRightsMailByID(mail.id),
            vats: this.vatsService.fetchVats(),

            demandeurPriseEnChargeInfos: this.courrier.priseEnChargeInfo?.demandeurContactId
              ? this.contactsService.getLowInformationsContactsiAdmin({
                id: [this.courrier.priseEnChargeInfo.demandeurContactId],
              })
              : of(null),
            counts: this.mailsService.fetchMailCounts(mail.id),
          });
        })
      )
      .subscribe({
        next: (res: {
          rightManagement: RightManagement;
          writeLockContact: ContactDto | null;
          mailRights: MailRightsDto;
          services: DropdownService[];
          allNatures: NatureDto[];
          documentsStatutes: DocumentStatusDto[];
          allSources: SourceDto[];
          userInfos: UserInfosDto;
          configuration: ConfigDto;
          myServices: MyOwnServiceDto[];
          calendarTranslations: AssetsCalendarFr;
          lockInfos: MailLockEntryDTO[];
          roles: DropdownRole[];
          participants: MailDestinataire[];
          multipleStatutes: MultipleStatutesDTO[];
          mutlipleStatutesForThisMail: MailMultipleStatutesDTO[];
          userContacts: UserContact[];
          validationUsers: string;
          rightsForThisMail: MeRightMail;
          vats: VatDto[];
          demandeurPriseEnChargeInfos: LowInformationsDTO[] | null;
          counts: MailCountsDTO;
        }) => {
          this.rightManagement = res.rightManagement;
          if (res.writeLockContact) {
            this.handleWriteLockContact(res.writeLockContact);
          }
          this.handleMailRights(res.mailRights);
          this.handleIdelibeRights(res.userInfos);
          this.handleServices(res.services);
          this.handleNatures(res.allNatures);
          this.handleDocumentsStatutes(res.documentsStatutes);
          this.handleSources(res.allSources);
          this.handleUserInfos(res.userInfos);
          // After getting the userInfos, we need to get all the groups in which the user is included
          this.handleGroupsMembersOfContactIds();
          this.handleConfig(res.configuration);
          this.handleCalendarTranslations(res.calendarTranslations);
          this.handleLockInfosForAMail(res.lockInfos);
          this.handleRoles(res.roles);
          this.handleParticipants(res.participants);
          this.handleMultipleStatutes(res.multipleStatutes);
          this.handleMailMultipleStatutes(res.mutlipleStatutesForThisMail);
          this.handleUsers(res.userContacts);

          this.handleFileRights(res);
          this.handleRightsForThisMail(res.rightsForThisMail);
          this.setActualTab();

          this.handleValidationUsers(res.validationUsers);
          this.handleMailRecipientsWithFullInfos(res.counts);
          this.handleMailLinks(res.counts);
          this.handleVats(res.vats);
          this.handlePriseEnChargeDemandeur(res.demandeurPriseEnChargeInfos);
          this.initArrowsAndTabs();
          this.patchMailActiveForm(this.courrier);
          this.patchMailCenterNum();
          this.userServices = res.myServices;
          this.courrierTitle = new Mail(this.courrier);
          console.log(this.courrierTitle);

          this.spinner.hide();
        },
        error: (err: HttpErrorResponse) => {
          console.warn(`Une erreur s'est produite lors de l’initialisation des données`);
          console.error(err);
          this.mailsService.setCanAccessToMail(0);
          this.spinner.hide();
          this.errorDisplayed = this.translater.translate('errorInterceptor.noPermissionToViewMail');
        },
      });
  }

  private setActualTab(): void {
    if (localStorage.getItem('openedCourrierTabXL')) {
      const localTab = this.tabsArrayXL.find((tab) => tab.id === localStorage.getItem('openedCourrierTabXL'));
      const actualTab = localTab ? localTab : this.tabsArrayXL.find((tab) => tab.id === 'infos');

      this.mailTabActiveXL = actualTab.id;
    }
  }

  public changeCurrentTabId(event: string): void {
    this.mailTabActiveXL = event;
  }

  private handleWriteLockContact(contact: ContactDto): void {
    this.courrier.writeLock.contact = contact;
  }

  private handleMailRights(mailRights: MailRightsDto): void {
    this.rightMailsGlobal = mailRights;
  }

  private handleIdelibeRights(userInfos: UserInfosDto): void {
    if (this.clientType !== 'JVS') {
      if (userInfos.services.indexOf(this.courrier.serviceProprietaireId) !== -1) {
        this.iAdminService.getTenant().subscribe({
          next: (tenantsInfos) => {
            if (tenantsInfos?.applications.find((app) => app.name === 'iDélibé Backoffice')) {
              this.iDelibeService.getUserAccessToiDelibe().subscribe({
                next: (userAccessDelibe) => {
                  if (userAccessDelibe.exist && userAccessDelibe.canLogin) {
                    this.iDelibeService.getiDelibeRights().subscribe({
                      next: (res: MeRightsPointsSeancesDTO) => {
                        // If we have one, whenever the results in the array, we can check if he have addPoint = true;
                        if (res && res.typeSeanceRights?.length > 0) {
                          const right = res.typeSeanceRights.filter((typeSeanceRight) => typeSeanceRight.addPoint === true);
                          right.length > 0 ? (this.rightsDelibe = true) : (this.rightsDelibe = false);
                        }
                      },
                      error: (err) => {
                        console.error(err);
                        this.rightsDelibe = false;
                      },
                    });
                  } else this.rightsDelibe = false;
                },
                error: (err) => {
                  this.rightsDelibe = false;
                  console.error(err);
                },
              });
            } else this.rightsDelibe = false;
          },
          error: (error: Error) => {
            this.toastr.error(this.translater.translate('error.noTenantRetrieved'));
            console.error('Error : ', error);
            this.rightsDelibe = false;
          },
        });
      } else this.rightsDelibe = false;
    } else this.rightsDelibe = false;
  }

  private handleServices(services: DropdownService[]): void {
    const datasForService = manageServicesSetAsTreeSelect(services, this.translater);
    const servicesReceived = datasForService.servicesForSingleCheck;
    this.serviceList = datasForService.servicesForMultiCheck;
    this.servicesChildParent = manageServicesToBeMerged(services);

    this.services = services;
    const mailMainService = services.find((service) => service.id === this.courrier.serviceProprietaireId);

    if (mailMainService) {
      this.courrier.serviceProprietaire = mailMainService;
    }

    if (servicesReceived.length === 1) {
      this.f.serviceProprietaireId.setValue(servicesReceived[0].id);
    }
  }

  private handleNatures(natures: NatureDto[]): void {
    this.natureList = natures;
    this.naturesService
      .fetchMappedNaturesToPrimeNGDropdowns()
      .pipe(map((res: DropdownNature[]) => _.uniq(_.sortBy(res, 'label'), 'label')))
      .subscribe({
        next: (res: DropdownNature[]) => {
          this.natureListLV = res;
        },
        error: (err: HttpErrorResponse) => {
          console.error(err);
        },
      });
  }

  private handleDocumentsStatutes(statutes: DocumentStatusDto[]): void {
    this.statutGlobal = statutes;
    this.statutList = statutes;

    const courrierStatute: DocumentStatusDto | undefined = statutes.find((statute) => statute.id === this.courrier.statutId);

    if (courrierStatute) {
      this.courrier.statusGlobalBackground = null;
      this.courrier.statusGlobalName = null;
      this.courrier.statusGlobalColor = null;
      this.courrier['statusGlobalName'] = courrierStatute.description;
      this.courrier['statusGlobalBackground'] =
        courrierStatute.color && courrierStatute.color !== 'Pas de couleur' ? courrierStatute.color : '#ffffff';
      this.courrier['statusGlobalColor'] = this.getOppositeColor(
        courrierStatute.color && courrierStatute.color !== 'Pas de couleur' ? courrierStatute.color : '#ffffff'
      );
    }

    statutes.forEach((statute) => {
      if (!statute.notUsed) {
        this.statutGlobalLV.push({
          label: statute.description,
          value: statute.id,
          color: this.getOppositeColor(statute.color && statute.color !== 'Pas de couleur' ? statute.color : '#ffffff'),
          background: statute.color && statute.color !== 'Pas de couleur' ? statute.color : '#ffffff',
          ordre: statute.ordreAffichage,
        });
      }
      this.statutListLV.push({ label: statute.description, value: statute.id });
    });
    this.statutListLV = _.sortBy(this.statutListLV, 'label');
    this.statutListLV = _.uniq(this.statutListLV, 'label');
    this.listen2TypeChange();
  }

  private handleSources(sources: SourceDto[]): void {
    this.sourceList = sources;
    this.sourcesService
      .fetchMappedSourcesToPrimeNGDropdowns()
      .pipe(map((res: DropdownSource[]) => _.uniq(_.sortBy(res, 'label'), 'label')))
      .subscribe({
        next: (res: DropdownSource[]) => {
          this.sourceListLV = res;
        },
        error: (err: HttpErrorResponse) => {
          console.error(err);
        },
      });
  }

  private handleUserInfos(infos: UserInfosDto): void {
    this.userInfos = infos;
  }

  private handleGroupsMembersOfContactIds(): void {
    this.groupsService.getGroupesMembres({ contactIds: [this.userInfos.contactId] }).subscribe({
      next: (res: GroupsMembersDTO[]) => {
        this.groupsMemberUserConnected = res;
      },
      error: () => {
        this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingGroupMembers'));
      },
    });
  }

  private handleConfig(config: ConfigDto): void {
    this.configuration = config;
  }

  private handleCalendarTranslations(translations: AssetsCalendarFr): void {
    this.locale4Calendar = translations;
  }

  private handleLockInfosForAMail(lockInfos: MailLockEntryDTO[]): void {
    this.locksInfo = lockInfos;
    const lastLocks: MailLockEntryDTO[] = lockInfos;
    const hasAlreadySomeOneWhoWrite: MailLockEntryDTO = _.last(lockInfos);

    if (lockInfos.length && hasAlreadySomeOneWhoWrite.lockMode === 'Write' && this.userInfos.contactId !== hasAlreadySomeOneWhoWrite.contactId) {
      this.toastr.warning("Quelqu'un modifie actuellement ce courrier");
    } else {
      let lastLockVersion = 0;

      if (lastLocks.length > 0) {
        lastLockVersion = _.last(lastLocks).version;
      } else if (this.courrier.version) {
        lastLockVersion = this.courrier.version;
      } else {
        lastLockVersion = 1;
      }
      this.lock('Read', lastLockVersion);
    }
  }

  private handleRoles(roles: DropdownRole[]): void {
    this.rolesLV = roles;
  }

  private handleParticipants(participants: MailDestinataire[]): void {
    this.participants = [..._.unique(participants)];
    this.participants.map((participant) => new MailDestinataire(participant));
    const obsArray: Observable<ContactDto | MailDestinataire>[] = [];

    for (const participant of this.participants) {
      if (participant.type === 'DESTINATAIRE') {
        if (participant.contactId && !participant.contactIdiAdmin) {
          obsArray.push(this.contactsService.fetchContact(participant.contactId, 'iCourrier'));
        }

        if (!participant.contactIdiAdmin && participant.contactIdiAdmin) {
          obsArray.push(this.contactsService.fetchContact(participant.contactIdiAdmin, 'iAdmin'));
        }
      }
    }

    forkJoin(obsArray).subscribe({
      next: (res: (MailDestinataire | ContactDto)[]) => {
        res.forEach((el) => {
          const participant = this.participants.find((p) => p.id === el.id);

          if (participant) {
            if (isRecipientMail(el)) {
              participant.name = (el.nom ? el.nom : '') + ' ' + (el.prenom ? el.prenom : '');
              participant.firstname = el.prenom ? el.prenom : '';
              participant.lastname = el.nom ? el.nom : '';
            } else {
              const relatedService = this.services.find((service) => service.id === el.id);

              if (relatedService) {
                participant.name = relatedService.description;
                participant.firstname = relatedService.codeService;
                participant.lastname = relatedService.description;
              }
            }
          }
        });

        this.participants = _.uniq(this.participants, 'contactId');

        function isRecipientMail(el: MailDestinataire | ContactDto): el is MailDestinataire {
          return el instanceof MailDestinataire;
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error(err);
      },
    });
  }

  private handleMultipleStatutes(multipleStatutes: MultipleStatutesDTO[]): void {
    const copy: (MultipleStatutesDTO & { textColor?: string; color?: string })[] = [...multipleStatutes];
    const tagList = [];
    copy.forEach((statute) => {
      statute.textColor = statute.color && statute.color !== 'Pas de couleur' ? this.getOppositeColor(statute.color) : '#000000';

      tagList.push({
        label: statute.description,
        value: statute.id,
        color: statute.color,
        textColor: statute.textColor,
        notUsed: statute.notUsed,
        cocherAjouterDroitAccesGroupeID: statute.cocherAjouterDroitAccesGroupeID,
        courrierActionDroitCocherGroupeID: statute.courrierActionDroitCocherGroupeID,
        courrierActionDroitDecocherGroupeID: statute.courrierActionDroitDecocherGroupeID,
        ordreAffichage: statute.ordreAffichage,
        servicesAuthorized: statute.servicesAuthorized,
      });
    });
    this.tags = tagList;
  }

  private handleMailMultipleStatutes(mailMultipleStatutes: MailMultipleStatutesDTO[]): void {
    const copy: (MailMultipleStatutesDTO & { textColor?: string; color?: string })[] = [...mailMultipleStatutes];
    const tagMailList = [];
    //! Attention subtilité : tagOfMail.statusId c'est l'id de this.tags.id . En effet, avant dans Infodoc c'était des statuts :)
    copy.forEach((tagOfMail) => {
      tagMailList.push({
        id: tagOfMail.id,
        mailId: tagOfMail.mailId,
        statusId: tagOfMail.statusId,
        description: tagOfMail.description,
        creationDate: tagOfMail.creationDate,
        color: _.first(this.tags.filter((x) => x.value === tagOfMail.statusId))?.color,
        textColor:
          tagOfMail.color !== null && tagOfMail.color !== undefined && tagOfMail.color !== 'Pas de couleur'
            ? this.getOppositeColor(tagOfMail.color)
            : '#000000',
        courrierActionDroitDecocherGroupeID: this.tags.find((tag) => tag.value === tagOfMail.statusId)?.courrierActionDroitDecocherGroupeID,
      });
    });
    this.tagsCourrier = tagMailList;
  }

  private handleUsers(userContacts: UserContact[]): void {
    this.listOfUsers = [...userContacts];
  }

  private handleMailFiles(counts: MailCountsDTO): void {
    const foundFilesTab = this.tabsArrayXL.find((tab) => tab.id === 'files');
    if (foundFilesTab) {
      foundFilesTab.count = counts.countFiles;
    } else {
      this.tabsArrayXL.splice(1, 0, {
        label: this.translater.translate('files'),
        id: 'files',
        count: counts.countFiles,
        icon: 'courrier_tabs_fichiers',
      });
    }
  }

  private handleValidationUsers(validationUsers: string): void {
    this.courrier.validationUsers = validationUsers;
  }

  private handleMailRecipientsWithFullInfos(counts: MailCountsDTO): void {
    const foundRecipientTab = this.tabsArrayXL.find((tab) => tab.id === 'recipients');
    if (foundRecipientTab) {
      foundRecipientTab.count = counts.countDestinataires;
    }
  }

  private handleMailLinks(counts: MailCountsDTO): void {
    const foundLinkTab = this.tabsArrayXL.find((tab) => tab.id === 'links');

    if (foundLinkTab) {
      foundLinkTab.count = counts.countLinks;
    }
  }

  private handleFileRights(res): void {
    // Handle files rights / view
    this.foundServiceRight = res.mailRights.mails.find((mailRight) => mailRight.serviceId === this.courrier.serviceProprietaireId);
    // Métier : Vu avec KHA ce 20/10/25
    // Trouver le service dans cet objet sert à avoir une valeur inscrite grâce au droits.
    // Si on ne trouve pas le service cela veut dire qu'on utilise les droits par défauts => voir les fichiers est a true par défaut.

    if (!this.foundServiceRight || this.foundServiceRight.viewFile) {
      this.handleMailFiles(res.counts);
    } else {
      this.amountOfFiles = 0; // pas le droit => il ne pourra pas dupliquer les fichiers pour un point
      const foundFilesTab = this.tabsArrayXL.findIndex((tab) => tab.id === 'files');
      if (foundFilesTab > -1) {
        this.tabsArrayXL.splice(foundFilesTab, 1);
      }
    }
  }

  private handleRightsForThisMail(rights: MeRightMail): void {
    this.rightMail = rights;

    if (!this.rightMail.viewHistory && !this.rightMail.viewDroits) {
      const indexHistory = this.tabsArrayXL.findIndex((tab) => tab.id === 'historic');
      if (indexHistory > -1) {
        this.tabsArrayXL.splice(indexHistory, 1);
        this.mailTabActiveXL = 'infos';
      }
    }
    if (!this.rightMail.files.view) {
      this.mailTabActiveXL = 'infos';
    }
  }

  private handleVats(vats: VatDto[]): void {
    this.currentBac = null;
    const mappedVats: Bacs[] = vats.map((vat) => new Bacs(vat));
    const foundMappedVat = mappedVats.find((vat) => vat.id === this.courrier.bacId);

    if (foundMappedVat) {
      this.courrier.bacLabelForInfos = foundMappedVat.name;
    }

    this.bacs = mappedVats.filter((vat) => !vat.nePasUtilise && vat.transfertManuel);

    this.workflows.getWorkflowIdRight(this.courrier.id).subscribe({
      next: (res: WorkflowsRightMails) => {
        this.rightFlux = res;
      },
    });

    if (this.courrier?.bacId) {
      this.currentBac = this.bacs.find((vat) => vat.id === this.courrier.bacId);
    }
    if (this.courrier.workflowId) {
      this.workflows.getWorkflowId(this.courrier.id, this.courrier.workflowId).subscribe({
        next: (res: WorkflowInstanceDTO) => {
          this.courrier.workflowForInfos = new WorkflowInstance(res);

          if (this.currentBac) {
            this.currentBac.workFlow = res;
          }
        },
      });
    }
  }

  private handlePriseEnChargeDemandeur(demandeurPriseEnChargeInfos: LowInformationsDTO[] | null): void {
    if (demandeurPriseEnChargeInfos?.length) {
      this.courrier.priseEnChargeInfo.demandeurContactLabel =
        (demandeurPriseEnChargeInfos[0].prenom ? demandeurPriseEnChargeInfos[0].prenom : '') +
        ' ' +
        (demandeurPriseEnChargeInfos[0]?.nom ? demandeurPriseEnChargeInfos[0]?.nom : '');
    } else {
      this.courrier.priseEnChargeInfo ? (this.courrier.priseEnChargeInfo.demandeurContactLabel = '/') : null;
    }
  }

  collapse(direction: 'left' | 'middle'): void {
    this.collapsedState = direction;
    switch (direction) {
      case 'left':
        this.panelSize = [0, 100];
        break;
      case 'middle':
        this.panelSize = [30, 70];
        break;
    }
  }
  hideFiles(): void {
    // this.areasEl.first.collapse();
    // this.filesAreHidden = true;
  }

  showFiles(): void {
    // this.areasEl.first.expand();
    // this.filesAreHidden = false;
  }

  /**
   *
   * @param isFromAction boolean used when ngOnInit is called by
   */
  initArrowsAndTabs(): Promise<boolean> {
    return new Promise((resolve) => {
      // Deux choix s'offrent a nous.
      // 1) On a showDestinataireModal => on affiche l'onglet des destinataires. En effet dans celui-ci, le compo' va checker si on a showDestinataireModal et afficher la modale d'ajout de destinataires
      //      Ensuite, lorsque cette modale sera fermée, le même compo' va checker si showModalDocument existe. Si oui, il affichera la modale d'ajout de documents
      // 2 ) Nous n'avons pas de showDestinataireModal et donc il faut checker showModalDocument afin d'afficher si besoin la modale.

      if (sessionStorage.getItem('showDestinataireModal') === '1') {
        this.mailTabActiveXL = 'recipients';
      } else if (sessionStorage.getItem('showModalDocument') === '1') {
        this.openDocument();
      }
      resolve(true);
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  public receiveDestinataire(event): void {
    this.tabsArrayXL.find((tab) => tab.id === 'recipients') ? (this.tabsArrayXL.find((tab) => tab.id === 'recipients').count = event.length) : null;
  }

  patchMailActiveForm(courrier?): void {
    if (courrier) {
      this.form.patchValue({
        typeEntrantSortant: courrier.typeEntrantSortant,
        confidentiel: courrier.confidentiel,
        refExpediteur: courrier.refExpediteur,
        objet: courrier.objet,
        dateEntree: courrier.dateEntree !== null ? new Date(courrier.dateEntree) : null,
        dateDocument: courrier.dateDocument !== null ? new Date(courrier.dateDocument) : null,
        dateEcheance: courrier.dateEcheance !== null ? new Date(courrier.dateEcheance) : null,
        datePostale: courrier.datePostale !== null ? new Date(courrier.datePostale) : null,
        serviceProprietaireId: courrier.serviceProprietaireId,
        expediteurId: courrier.expediteurId,
        expediteurIdiAdmin: courrier.expediteurIdiAdmin,
        natureId: courrier.natureId,
        sourceId: courrier.sourceId,
        statutId: courrier.statutId,
        remarques: courrier.remarques,
        classementId: courrier.classementId,
        chemiseId: courrier.chemiseId,
        classeurId: courrier.classeurId,
        referenceRecommande: courrier.referenceRecommande,
        centreNumerisationId: courrier.centreNumerisationId,
      });
    }
    this.typeEntrantSortant = this.f.typeEntrantSortant.value;
  }

  patchMailCenterNum(): void {
    if (this.courrier.centreNumerisation?.id) {
      this.courrier.centreNumLabel = this.courrier.centreNumerisation.description;
    } else if (this.courrier?.centreNumerisationId) {
      this.getCentreNums().then(() => {
        const centreNumCourrier = this.numerisations_center.find((x) => x.value === this.courrier.centreNumerisationId);
        this.courrier.centreNumLabel = centreNumCourrier?.label ? centreNumCourrier.label : null;
      });
    }
  }

  handleValidationAndSignature(): void {
    if (this.rightMailsGlobal.menu.validationDocuments && this.files?.length > 0) {
      this.filesService.fetchMailFilesToValidate(this.courrier.id).subscribe({
        next: (filesToValidate) => {
          this.courrier.filesToValidate = [];
          this.courrier.filesToValidate = filesToValidate;
        },
      });
    }
    if (this.rightMailsGlobal.menu.signatureDocuments && this.files?.length > 0) {
      this.filesService.fetchMailFilesToSignIndividually(this.courrier.id).subscribe({
        next: (filesToSign) => {
          this.courrier.filesToSign = [];
          this.courrier.filesToSign = filesToSign;
        },
      });
    }
  }

  getStatutList(): void {
    this.statutGlobalLV = [];
    this.statutGlobal = [];
    this.documentsService.fetchDocumentsStatutes().subscribe({
      next: (res: DocumentStatusDto[]) => {
        this.statutGlobal = res;

        res.forEach((documentStatute) => {
          if (this.courrier.statutId === documentStatute.id) {
            this.courrier.statusGlobalBackground = null;
            this.courrier.statusGlobalName = null;
            this.courrier.statusGlobalColor = null;
            this.courrier['statusGlobalName'] = documentStatute.description;
            this.courrier['statusGlobalBackground'] =
              documentStatute.color && documentStatute.color !== 'Pas de couleur' ? documentStatute.color : '#ffffff';
            this.courrier['statusGlobalColor'] = this.getOppositeColor(
              documentStatute.color && documentStatute.color !== 'Pas de couleur' ? documentStatute.color : '#ffffff'
            );
          }

          if (!documentStatute.notUsed) {
            this.statutGlobalLV.push({
              label: documentStatute.description,
              value: documentStatute.id,
              // * Need to check if the color isn't null || 'Pas de couleur'. If it's => it's gonna be a display problem
              color: this.getOppositeColor(documentStatute.color && documentStatute.color !== 'Pas de couleur' ? documentStatute.color : '#ffffff'),
              background: documentStatute.color && documentStatute.color !== 'Pas de couleur' ? documentStatute.color : '#ffffff',
              ordre: documentStatute.ordreAffichage,
            });
            this.statutListLV.push({ label: documentStatute.description, value: documentStatute.id });
          }
        });

        this.statutListLV = _.sortBy(this.statutListLV, 'label');
        this.statutListLV = _.uniq(this.statutListLV, 'label');
        this.statutList = res;
        this.listen2TypeChange();
      },
    });
  }

  getOppositeColor(bgColor): string {
    if (bgColor) {
      const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      const r = parseInt(color.substring(0, 2), 16); // hexToR
      const g = parseInt(color.substring(2, 4), 16); // hexToG
      const b = parseInt(color.substring(4, 6), 16); // hexToB
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    } else {
      return '#000000';
    }
  }

  listen2TypeChange(): void {
    const defaultEntrant = this.statutList.find((statut) => statut.defaultEntrant === true);
    const defaultSortant = this.statutList.find((statut) => statut.defaultSortant === true);
    this.f.typeEntrantSortant.valueChanges.subscribe({
      next: (typeESI) => {
        this.typeEntrantSortant = typeESI;
        switch (typeESI) {
          case 'E':
            if (defaultEntrant) {
              this.f.statutId.setValue(defaultEntrant.id);
            }
            break;
          case 'S':
            if (defaultSortant) {
              this.f.statutId.setValue(defaultSortant.id);
            }
            break;

          default:
            break;
        }
        this.f.statutId.updateValueAndValidity();
      },
    });
  }

  private initializeErrors(): void {
    this.errorService
      .getErrors()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (errors) => {
          this.openErrorModal(errors, 'warningMode');
        },
      });
  }

  public openErrorModal(messages, mode: string): void {
    const ref = this.dialogService.open(HttpErrorModalComponent, {
      dismissableMask: false,
      width: '60vw',
      header: 'Avertissement',
      baseZIndex: 1000,
      data: {
        messages: messages,
        mode: mode,
      },
    });
    ref.onClose.subscribe({
      next: (value) => {
        if (value === true) {
          this.saveMail(this.courrier, true);
        }
      },
    });
  }

  public saveMail(data, skipFalse?: boolean): void {
    this.mailsService.addMail(data, skipFalse).subscribe({
      next: (response: MailCreatedDTO) => {
        this.courrier = new MailDetails(response);
        this.isCourrier = true;
      },
      error: (error) => {
        console.error('Error : ', error);
      },
    });
  }

  // receive selected file and emit to fileViewer and superReader
  public receiveCurrentFile(file: MailFileDto): void {
    this.fileToShow = null;

    if (file) {
      this.fileToShow = new MailFileVersionDisplayedDropdown(file);
      this.currentFile = file;
      const userServiceRightForThisMail = this.userServices.find((userService) => userService.serviceId === this.courrier.serviceProprietaireId);
      if (userServiceRightForThisMail.refuserVisualisationVersionsFichiers || this.fileToShow.version === 1) {
        this.listOfVersion = [];
        return;
      }
      this.filesService.getAllVersionsOfFile(this.courrier.id, file.id).subscribe({
        next: (res) => {
          this.listOfVersion = res.map((versionFile) => new MailFileVersionDisplayedDropdown(versionFile));
        },
      });
    }
  }

  public changeVersion(event: MailFileVersionDisplayedDropdown, op: OverlayPanel): void {
    if (event.value === this.fileToShow.id) {
      op.hide();
      return;
    }
    this.isAnotherVersionThanVersionOfFile = event.value !== this.currentFile.id;
    this.fileToShow = event;
    op.hide();
  }

  public restoreVersion(): void {
    this.spinner.show();
    this.filesService.restoreFile(this.courrier.id, this.currentFile.id, this.fileToShow.id).subscribe({
      next: (mailFileRestored) => {
        this.spinner.hide();
        this.isAnotherVersionThanVersionOfFile = false;
        this.dataService.setRefreshFileList(mailFileRestored.id);
      },
    });
  }

  public receiveAmountOfFiles(number: number): void {
    this.amountOfFiles = number;
  }

  getTagsByMail(courrier): Promise<boolean> {
    return new Promise((resolve) => {
      forkJoin({
        tags: this.multipleStatutesService.getMultipleStatus().pipe(
          catchError(() => {
            this.toastr.error("Une erreur s'est produite lors de la récupération des étiquettes");
            return of([]);
          })
        ),
        mailTags: this.multipleStatutesService.getMailMultipleStatutes(courrier.id).pipe(
          catchError(() => {
            this.toastr.error("Une erreur s'est produite lors de la récupération des étiquettes du courrier");
            return of([]);
          })
        ),
      }).subscribe((value) => {
        this.formatTags(value.tags);
        this.formatMailTags(value.mailTags);
        resolve(true);
      });
    });
  }

  private formatTags(tags: MultipleStatutesDTO[]): void {
    const tagList: MultipleStatutes[] = [];
    if (tags?.length > 0) {
      tags.forEach((item) => {
        tagList.push({
          label: item.description,
          value: item.id,
          color: item.color,
          textColor: item.color !== null && item.color !== 'Pas de couleur' ? this.getOppositeColor(item.color) : '#000000',
          notUsed: item.notUsed,
          cocherAjouterDroitAccesGroupeID: item.cocherAjouterDroitAccesGroupeID,
          courrierActionDroitCocherGroupeID: item.courrierActionDroitCocherGroupeID,
          courrierActionDroitDecocherGroupeID: item.courrierActionDroitDecocherGroupeID,
          ordreAffichage: item.ordreAffichage,
          servicesAuthorized: item.servicesAuthorized,
        });
      });
    }
    this.tags = tagList;
  }

  private formatMailTags(mailTags: MailMultipleStatutesDTO[]): void {
    const tagMailList: MailMultipleStatutes[] = [];
    if (mailTags.length > 0) {
      mailTags.map((tagOfMail) => {
        //! Attention subtilité : tagOfMail.statusId c'est l'id de this.tags.id . En effet, avant dans Infodoc c'était des statuts :)
        tagMailList.push({
          id: tagOfMail.id,
          mailId: tagOfMail.mailId,
          statusId: tagOfMail.statusId,
          description: tagOfMail.description,
          creationDate: tagOfMail.creationDate,
          color: _.first(this.tags.filter((x) => x.value === tagOfMail.statusId))?.color,
          textColor:
            tagOfMail.color !== null && tagOfMail.color !== undefined && tagOfMail.color !== 'Pas de couleur'
              ? this.getOppositeColor(tagOfMail.color)
              : '#000000',
          courrierActionDroitDecocherGroupeID: this.tags.find((tag) => tag.value === tagOfMail.statusId)?.courrierActionDroitDecocherGroupeID,
        });
      });
    }
    this.tagsCourrier = tagMailList;
  }

  openCreateModal(): void {
    sessionStorage.setItem('courrierIDAnswer', this.courrier.id.toString());
    let mailType = 'E';
    //le 23/02/2024, Gwen a donné ces informations métiers :
    // répondre a une fiche courrier qui est de base 'entrant' => créer un sortant (si on en a le droit)
    if (this.courrier.typeEntrantSortant == 'E') {
      mailType = this.userInfos.encodageNouveauSortant ? 'S' : 'E';
    }
    // répondre a une fiche courrier qui est de base 'sortant' => créer un entrant (si on en a le droit)
    if (this.courrier.typeEntrantSortant == 'S') {
      mailType = this.userInfos.encodageNouveauEntrant ? 'E' : 'S';
    }
    // répondre a une fiche courrier qui est de base 'interne' => créer un interne
    if (this.courrier.typeEntrantSortant == 'I') {
      mailType = 'I';
    }
    const data: MailInfosViaExtraStateRouter = {
      isAnswerMode: true,
      origin: 'courrierFicheForm',
      mailId: this.courrier.id,
      mail: this.courrier,
      expediteurId: this.courrier.expediteurId,
      expediteurIdiAdmin: this.courrier.expediteurIdiAdmin,
      mailType: mailType,
      isNew: true,
    };
    sessionStorage.setItem('showModalDocument', '1');

    this.router.navigate(['/private/ic/new'], { state: data });
  }

  editCourrier(courrier): void {
    this.mailsLockUnlockService.getLockInfo(this.courrier.id).subscribe({
      next: (res) => {
        this.locksInfo = res.map((item) => new MailLockEntry(item));
        let lastLocks = [];
        lastLocks = res;
        let hasAlreadySomeOneWhoWrite = null;
        hasAlreadySomeOneWhoWrite = _.last(res);
        if (res.length > 0 && hasAlreadySomeOneWhoWrite.lockMode === 'Write' && this.userInfos.contactId !== hasAlreadySomeOneWhoWrite.contactId) {
          this.toastr.warning("Quelqu'un modifie actuellement ce courrier");
        } else {
          let lastLockVersion = 0;
          if (lastLocks.length > 0) {
            lastLockVersion = _.last(lastLocks).version;
          } else if (this.courrier.version) {
            lastLockVersion = this.courrier.version;
          } else {
            lastLockVersion = 1;
          }
          this.lock('Write', lastLockVersion).then(() => {
            this.router.navigate(['/private/ic/new/' + courrier.id, { mode: 'edit' }]);
          });
        }
      },
    });
  }

  openAssistant(): void {
    this.actionModal = false;
    this.dialogService.open(CModeChoiceModalComponent, {
      dismissableMask: false,
      width: '60vw',
      header: 'Type de mail',
      baseZIndex: 1000,
      data: {
        newMail: this.courrier,
        modeAnswer: false,
        showOnlyEmailOption: true,
      },
    });
  }

  getMailByID(mail?): void {
    const courrier = mail ? mail : this.route.snapshot.params;
    this.mailsService.fetchMailsById(courrier.id).subscribe({
      next: (res: MailDTO) => {
        this.courrier = new MailDetails(res);
        if (mail) {
          this.getStatutList();
        } else {
          this.mailsService.setCanAccessToMail(res.id);
        }
      },
      error: () => {
        this.mailsService.setCanAccessToMail(0);
        this.errorDisplayed = this.translater.translate('errorInterceptor.noPermissionToViewMail');
      },
    });
  }

  getDestinataires(courrier): Promise<boolean> {
    return new Promise((resolve) => {
      this.mailsService.fetchMailCounts(courrier.id).subscribe({
        next: (counts) => {
          this.tabsArrayXL.find((tab) => tab.id === 'recipients')
            ? (this.tabsArrayXL.find((tab) => tab.id === 'recipients').count = counts.countDestinataires)
            : null;
          if (this.mailTabActiveXL === 'recipients') {
            //* Avec un array forcé de se modifier, on va obliger le component destinataire de lancer son ngOnInit grâce a l'input. Mais on en av le faire que si on est bien sur l'onglt destinataires
            this.listToReloadDatas = [];
            this.listToReloadDatas = [{}];
          }
          resolve(true);
        },
      });
    });
  }

  validate(): void {
    this.confirmService.confirm({
      message: 'Voulez-vous vraiment valider ce courrier ?',
      key: 'courrierFicheForm',
      accept: () => {
        const data = {
          mailIds: [this.courrier.id],
        };
        this.mailsService.validateMail(data).subscribe({
          next: () => {
            this.toastr.success('Modification enregistrée avec succès');
            this.getMailByID();
          },
          error: () => {
            this.toastr.error("Vous n'avez pas le droit de valider ce courrier");
          },
        });
      },
    });
  }

  transfer(): void {
    this.actionModal = false;
    const ref = this.dialogService.open(RecipientModalComponent, {
      closable: false,
      showHeader: false,
      dismissableMask: false,
      header: 'Destinataires',
      width: '60vw',
      baseZIndex: 1000,
      data: {
        courrierID: this.courrier.id,
      },
    });
    ref.onClose.subscribe({
      next: (data: RecipientModalOnCloseDatas) => {
        if (data) {
          const arrayIDToCheck: number[] = [];

          if (data.contactArray.length) {
            data.contactArray.forEach((item) => {
              arrayIDToCheck.push(item.value);
            });
          }

          if (arrayIDToCheck?.length) {
            this.fetchReplacingPeople(arrayIDToCheck, data);
          } else {
            this.setDatasAndCallAddDestinataires(data, []);
          }
        }
      },
    });
  }

  private setDatasAndCallAddDestinataires(data: RecipientModalOnCloseDatas, remplacantArray): void {
    if (remplacantArray.length) {
      data.contactArray = remplacantArray;
    }
    this.addDestinataires(data);
  }

  private fetchReplacingPeople(arrayIDToCheck, data: RecipientModalOnCloseDatas): void {
    this.contactService.fetchContactsRemplacantsiCourrier(arrayIDToCheck).subscribe({
      next: (res) => {
        const hasAbsentPeopleArray: ContactsRemplacantDTO[] = [];
        if (res?.length) {
          res.forEach((remplacant) => {
            data.contactArray.forEach((dest) => {
              if (remplacant.absent === true && dest.value === remplacant.contactId) {
                hasAbsentPeopleArray.push(remplacant);
              }
            });
          });
        }
        if (hasAbsentPeopleArray.length > 0) {
          this.confirmReplaceContactsInHolidays(res, data);
        } else {
          this.setDatasAndCallAddDestinataires(data, []);
        }
      },
    });
  }

  private confirmReplaceContactsInHolidays(res: ContactsRemplacantDTO[], data: RecipientModalOnCloseDatas): void {
    const remplacantArray = [];
    this.confirmService.confirm({
      message: 'Souhaitez-vous remplacer automatiquement les personnes qui sont en congés ?',
      key: 'remplacant',
      accept: () => {
        async.eachSeries(
          res,
          (item, next) => {
            if (item.absent) {
              const contactArrayLinked = data.contactArray.filter((dest) => dest.value === item.contactId);
              if (contactArrayLinked?.length) {
                this.contactsService.fetchContact(item.remplaceParContactId, 'iAdmin').subscribe({
                  next: (res: ContactDto) => {
                    if (res) {
                      remplacantArray.push(
                        contactArrayLinked[0],
                        new Contact({
                          value: item.remplaceParContactId,
                          name: (res.prenom ? res.prenom : '') + ' ' + (res.nom ? res.nom : ''),
                          label: (res.prenom ? res.prenom : '') + ' ' + (res.nom ? res.nom : ''),
                          type: 'DESTINATAIRE',
                          lastname: res.prenom ? res.prenom : '',
                          nom: res.nom ? res.nom : '',
                          prenom: res.prenom ? res.prenom : '',
                        })
                      );
                      next();
                    } else next();
                  },
                });
              } else next();
            } else next();
          },
          () => {
            this.setDatasAndCallAddDestinataires(data, remplacantArray);
          }
        );
      },
      reject: () => {
        this.setDatasAndCallAddDestinataires(data, []);
      },
    });
  }

  /**
   * Method to add one or multiple recipients to the current courrier
   * @param newDestArray array of destinataire
   */
  public addDestinataires(data: RecipientModalOnCloseDatas): void {
    if (data) {
      this.spinner.show();
      this.addFreeRecipients(data.freeRecipientArray).then(() => {
        const listOfDatas = {
          libre: null,
          contacts: [
            ...data.contactArray.map((item) => ({
              contactId: item.value,
              historiqueDescription: item.label,
            })),
            ...data.usersArray.map((item) => ({
              contactIdiAdmin: item.value,
              historiqueDescription: item.label,
            })),
          ],
          serviceIds: data.serviceArray.map((item) => item.value),
          groupeIds: data.groupsArray.map((item) => item.id),
        };
        this.recipientsService.addMailsDestinataires(this.courrier.id, listOfDatas).subscribe({
          next: () => {
            this.toastr.success('Destinataire(s) ajouté(s)!');
            this.spinner.hide();
            this.getDestinataires(this.courrier);
          },
        });
      });
    }
  }

  private addFreeRecipients(
    freeRecipientArray: {
      id: string;
      name: string;
    }[]
  ): Promise<boolean> {
    return new Promise((resolve) => {
      if (!freeRecipientArray?.length) return resolve(true);
      async.eachSeries(
        freeRecipientArray,
        (item, next) => {
          const destinataireInput = {
            libre: item.name,
            contacts: [],
          };
          this.recipientsService.addMailsDestinataires(this.courrier.id, destinataireInput).subscribe({
            next: () => {
              next();
            },
            error: (error) => {
              console.error('Error : ', error);
              this.toastr.error("Erreur lors de l'ajout de : " + destinataireInput.libre);
              next();
            },
          });
        },
        () => {
          resolve(true);
        }
      );
    });
  }

  receive_linkCount(linkCount): void {
    this.tabsArrayXL.find((tab) => tab.id === 'links') ? (this.tabsArrayXL.find((tab) => tab.id === 'links').count = linkCount) : null;
  }

  changeGlobalStatus(courrier, event): void {
    let arrayActions = [];
    if (event && event.value) {
      async.waterfall([
        (cb) => {
          // On va check si y a des actions pour afficher un avertissements
          this.actionsService.getMailsActions(courrier.id).subscribe({
            next: (res) => {
              arrayActions = res.filter((x) => x.statut !== 'Terminé' && x.statut !== 'Abandonné');
              cb(null);
            },
          });
        },
        () => {
          if (arrayActions.length > 0) {
            this.documentsService.getDocumentsStatutes().subscribe({
              next: (res) => {
                let statuts = [];
                statuts = res.filter((status) => status.id === event.value);
                let isTerminatedOrForgiven = [];
                isTerminatedOrForgiven = statuts.filter((x) => x.globalStatutId === 6 || x.globalStatutId === 7);
                if (arrayActions.length > 0 && isTerminatedOrForgiven.length > 0) {
                  this.confirmService.confirm({
                    message: 'Des actions sont encore en cours sur le courrier, êtes-vous sûr de vouloir mettre à jour le statut ?',
                    key: 'courrierFicheForm',
                    accept: () => {
                      this.mailsService.patchMailStatus(courrier.id, event.value).subscribe({
                        next: () => {
                          this.toastr.success('Le statut a été mis à jour !');
                          this.dataService.setReloadToTrue(true);
                          this.showStatusDropdown = false;
                          this.getMailByID(courrier.id);
                        },
                      });
                    },
                  });
                } else {
                  this.mailsService.patchMailStatus(courrier.id, event.value).subscribe({
                    next: () => {
                      this.toastr.success('Le statut a été mis à jour !');
                      this.dataService.setReloadToTrue(true);
                      this.showStatusDropdown = false;
                      this.getMailByID(courrier.id);
                    },
                  });
                }
              },
            });
          } else {
            this.mailsService.patchMailStatus(courrier.id, event.value).subscribe({
              next: () => {
                this.toastr.success('Le statut a été mis à jour !');
                this.dataService.setReloadToTrue(true);
                this.showStatusDropdown = false;
                // this.initData(this.courrier.id);
                this.getMailByID(courrier.id);
              },
            });
          }
        },
      ]);
    }
  }

  receiveMailMode(event): void {
    this.router.navigate(['/private/ic/new/' + this.courrier.id, { mode: event }]);
  }

  pin(courrier): void {
    this.actionModal = false;
    let activate: boolean;
    this.spinner.show();
    if (courrier.pinned === null || courrier.pinned === false) {
      activate = true;
    } else {
      activate = false;
    }
    this.mailsService.pinMail(courrier.id, activate).subscribe({
      next: () => {
        activate === true ? this.toastr.success('Courrier épinglé !') : this.toastr.success('Courrier désépinglé !');
        this.initData(this.courrier.id);
        this.spinner.hide();
      },
    });
  }

  /**
   * Open modal to associate an action to the current courrier
   */
  createAction(): void {
    this.actionModal = false;
    const ref = this.dialogService.open(ActionCreateModalComponent, {
      dismissableMask: false,
      header: 'Créer une action',
      closable: false,
      baseZIndex: 1000,
      width: '70vw',
      data: {
        currentCourrier: this.courrier,
      },
    });

    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          this.listToReloadDatas = [];
          this.listToReloadDatas = [value];
        }
      },
    });
  }

  getCentreNums(): Promise<boolean> {
    return new Promise((resolve) => {
      this.numerisationCentersService.getGlobalCentreNumerisation().subscribe({
        next: (res: GlobalCentreNumerisationDTO[]) => {
          this.numerisations_center = [];
          if (res?.length > 0) {
            res.map((item) => {
              this.numerisations_center.push({ label: item.description, value: item.id });
            });
          } else {
            this.numerisations_center = [];
          }
          resolve(true);
        },
      });
    });
  }

  openBadRoutage(): void {
    this.actionModal = false;
    this.mailsService.getMauvaisRoutageService(this.courrier.id).subscribe({
      next: (res) => {
        this.mauvais_routage = new BadRouting(res);
        if (res.serviceId) {
          this.mauvais_routage.description = this.services.find((s) => s.id === res.serviceId).description;
        }
        this.openMauvaisRoutage = true;
      },
    });
  }

  putBadRoutage(): void {
    if (this.formMauvaisRoutage.invalid) return;
    this.mailsService.putMauvaisRoutageService(this.courrier.id, this.formMauvaisRoutage.value).subscribe({
      next: () => {
        this.initData(this.courrier.id);
        this.dataService.setRefreshList(true);
        this.openMauvaisRoutage = false;
      },
    });
  }

  openPrendreEnCharge(): void {
    this.actionModal = false;
    const ref = this.dialogService.open(PrendreEnChargeModalComponent, {
      styleClass: 'super-compos-modal-content',
      header: this.translater.translate('takeCharge.title'),
      width: '60vw',
      dismissableMask: false,
      data: {
        courrier: this.courrier,
        services: this.servicesChildParent,
      },
    });
    ref.onClose.subscribe({
      next: (reload?: boolean) => {
        if (reload) {
          this.initData(this.courrier.id);
        }
      },
    });
  }

  refusePrendreEnCharge(): void {
    this.actionModal = false;
    this.confirmService.confirm({
      message: 'Voulez-vous vraiment refuser la prise en charge ?',
      key: 'courrierFicheForm',
      accept: () => {
        this.mailsTakeChargeService.refuseTakeInCharge(this.courrier.id).subscribe({
          next: () => {
            this.toastr.success('Modification enregistrée');
            this.dataService.setRefreshList(true);
            this.initData(this.courrier.id);
          },
        });
      },
    });
  }

  cancelPrendreEnCharge(): void {
    this.confirmService.confirm({
      message: 'Voulez-vous vraiment annuler la prise en charge ?',
      key: 'courrierFicheForm',
      accept: () => {
        this.mailsTakeChargeService.cancelTakeInCharge(this.courrier.id).subscribe({
          next: () => {
            this.toastr.success('Modification enregistrée');
            this.dataService.setRefreshList(true);
            this.actionModal = false;
            this.initData(this.courrier.id);
          },
        });
      },
    });
  }

  prendreEnChargeExclusive(): void {
    this.actionModal = false;
    this.confirmService.confirm({
      message: 'Voulez-vous vraiment prendre en charge de manière exclusive?',
      key: 'courrierFicheForm',
      accept: () => {
        this.mailsTakeChargeService.markAsTakeInChargeExclusive(this.courrier.id).subscribe({
          next: () => {
            this.toastr.success('Modification enregistrée');
            this.dataService.setRefreshList(true);
            this.initData(this.courrier.id);
          },
        });
      },
    });
  }

  prendreEnChargeCollective(): void {
    this.actionModal = false;
    this.confirmService.confirm({
      message: 'Voulez-vous vraiment prendre en charge de manière collective?',
      key: 'courrierFicheForm',
      accept: () => {
        this.mailsTakeChargeService.markAsTakeInChargeCollective(this.courrier.id).subscribe({
          next: () => {
            this.toastr.success('Modification enregistrée');
            this.dataService.setRefreshList(true);
            this.initData(this.courrier.id);
          },
        });
      },
    });
  }

  cloturePrendreEnCharge(): void {
    this.confirmService.confirm({
      message: 'Voulez-vous vraiment cloture la prise en charge ?',
      key: 'courrierFicheForm',
      accept: () => {
        this.mailsTakeChargeService.closeTakeInCharge(this.courrier.id).subscribe({
          next: () => {
            this.toastr.success('Modification enregistrée');
            this.dataService.setRefreshList(true);
            this.initData(this.courrier.id);
          },
        });
      },
    });
  }

  hideAlert(id: number): void {
    this.hideID = id;
  }

  deleteCourrier(courrier, activate): void {
    this.actionModal = false;
    this.confirmService.confirm({
      message: 'Voulez-vous vraiment ' + (activate ? 'supprimer' : 'réactiver') + ' ce courrier ?',
      key: 'courrierFicheForm',
      accept: () => {
        this.mailsService.deleteCourrier(courrier.id, activate).subscribe({
          next: () => {
            if (activate) {
              this.toastr.success('Le courrier a bien été supprimé');
              const activeCategoryCourrier = localStorage.getItem('activeCategoryCourrier') ? localStorage.getItem('activeCategoryCourrier') : 'all';
              this.router.navigateByUrl('/private/ic/courriers/' + activeCategoryCourrier);
            } else {
              this.toastr.success('Le courrier a bien été réactivé');
            }
            this.dataService.setReloadToTrue(true);
          },
        });
      },
    });
  }

  openDuplicate(): void {
    this.actionModal = false;
    this.dialogService.open(DuplicateModalsComponent, {
      dismissableMask: true,
      showHeader: false,
      styleClass: 'super-compos-modal-content',
      width: '50vw',
      baseZIndex: 1000,
      data: {
        courrier: this.courrier,
      },
    });
  }

  getLocksAccess(): Promise<boolean> {
    return new Promise((resolve) => {
      this.mailsLockUnlockService.getLockInfo(this.courrier.id).subscribe({
        next: (res) => {
          this.locksInfo = res.map((item) => new MailLockEntry(item));
          if (res.length > 0) {
            this.currentUserLockInfo = _.last(res.filter((x) => x.contactId === this.userInfos?.contactId));
          } else {
            this.currentUserLockInfo = null;
          }

          const contactIds = this.locksInfo.filter((lock) => lock.contactId).map((lock) => lock.contactId);
          if (contactIds.length) {
            this.contactsService.getLowInformationsContactsiCourrier({ id: contactIds }).subscribe({
              next: (listOfContacts) => {
                this.locksInfo.map((item) => {
                  listOfContacts.forEach((c) => {
                    if (c.id === item.contactId) {
                      item.name = c.nom;
                    }
                  });
                });
                resolve(true);
              },
            });
          } else {
            resolve(true);
          }
        },
        error: (err) => {
          console.error(err);
          resolve(true);
        },
      });
    });
  }

  lock(mode: string, version: number): Promise<boolean> {
    return new Promise((resolve) => {
      this.mailsLockUnlockService.postLockUnlock(this.courrier.id, mode, version ? version : 1).subscribe({
        next: () => {
          if (mode === 'Write') {
            this.toastr.success('Le courrier est verrouillé');
          } else {
            this.toastr.success('Le courrier est déverrouillé');
          }
          this.getLocksAccess().then(() => {
            resolve(true);
          });
        },
      });
    });
  }
  unlock(mode: string): void {
    const data = {
      courrierIds: [this.courrier.id],
    };
    if (this.courrier.id) {
      this.mailsLockUnlockService.unLock(mode, data).subscribe({
        next: () => {
          this.toastr.success('Le courrier est déverrouillé');
          this.getLocksAccess();
        },
      });
    }
  }

  openIbacSidebar(): void {
    this.actionModal = false;
    this.openSidebarIBac = true;
    this.getBacs();
  }

  getBacs(courrier?): Promise<boolean> {
    return new Promise((resolve) => {
      this.currentBac = null;
      this.workflows.getBacs().subscribe({
        next: (listOfBacs: BacsDTO[]) => {
          const bacs = listOfBacs.map((x) => new Bacs(x));
          const mailBac = courrier?.bacId ? bacs.find((bac) => bac.id === courrier.bacId) : null;
          mailBac?.name ? (this.courrier.bacLabelForInfos = mailBac?.name) : null;

          this.currentBac = mailBac;

          this.bacs = bacs.filter((x) => x.nePasUtilise === false && x.transfertManuel === true);

          if (courrier?.workflowId) {
            this.workflows.getWorkflowId(courrier.id, courrier.workflowId).subscribe({
              next: (res: WorkflowInstanceDTO) => {
                this.courrier.workflowForInfos = new WorkflowInstance(res);
                if (this.currentBac) {
                  this.currentBac.workFlow = res;
                }
                resolve(true);
              },
            });
          } else {
            resolve(true);
          }
        },
      });
    });
  }

  public moveToBac(bac): void {
    this.confirmService.confirm({
      message: 'Voulez-vous déplacer le courrier dans ce bac ?',
      key: 'moveToBacConfirm',
      accept: () => {
        this.workflows.moveToBac(this.courrier.id, bac.id).subscribe({
          next: () => {
            this.toastr.success('Le courrier a été déplacé dans le bac: ' + bac.name);
            this.openSidebarIBac = false;
            this.dataService.setRefreshList(true);
            this.initData(this.courrier.id);
          },
        });
      },
    });
  }

  public cancelFlow(): void {
    this.workflows.cancelFlow(this.courrier.id, this.courrier.workflowForInfos.id).subscribe({
      next: () => {
        this.toastr.success('Le flux est annulé');
        this.spinner.hide;
        this.initData(this.courrier.id);
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Une erreur est survenue avec le flux!');
        this.spinner.hide();
      },
    });
  }
  public deleteFlow(): void {
    this.workflows.deleteFlow(this.courrier.id, this.courrier.workflowForInfos.id).subscribe({
      next: () => {
        this.toastr.success('Le flux a bien été supprimé');
        this.spinner.hide;
        this.initData(this.courrier.id);
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Une erreur est survenue avec le flux!');
        this.spinner.hide();
      },
    });
  }
  public resumeFlow(): void {
    this.workflows.resumeFlow(this.courrier.id, this.courrier.workflowForInfos.id).subscribe({
      next: () => {
        this.toastr.success('Le flux va reprendre');
        this.spinner.hide;
        this.initData(this.courrier.id);
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Une erreur est survenue avec le flux!');
        this.spinner.hide();
      },
    });
  }

  public retryFaultedFlow(): void {
    this.workflows.retryFaultedFlow(this.courrier.id, this.courrier.workflowForInfos.id).subscribe({
      next: () => {
        this.toastr.success('Le flux va reprendre');
        this.spinner.hide;
        this.initData(this.courrier.id);
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Une erreur est survenue avec le flux!');
        this.spinner.hide();
      },
    });
  }

  public startFlowManually(): void {
    this.workflows.startFlowManually(this.courrier.id).subscribe({
      next: () => {
        this.toastr.success('Le flux est lancé');
        this.spinner.hide;
        this.initData(this.courrier.id);
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Une erreur est survenue avec le flux!');
        this.spinner.hide();
      },
    });
  }

  openDocument(): void {
    sessionStorage.removeItem('showModalDocument');
    const ref = this.dialogService.open(CModeChoiceModalComponent, {
      dismissableMask: false,
      header: 'Type de document',
      width: '60vw',
      baseZIndex: 1000,
      data: {
        modeAnswer: false,
        newMail: this.courrier,
        mailId: this.courrier.id,
      },
    });
    ref.onClose.subscribe({
      next: (value) => {
        switch (value) {
          case 'mailNoModel':
            // KEEP THE EMIT For courrierEditionForm
            this.router.navigate(['/private/ic/new/' + this.courrier.id, { mode: value }]);
            break;
          case 'mailModel':
            // KEEP THE EMIT For courrierEditionForm
            this.router.navigate(['/private/ic/new/' + this.courrier.id, { mode: value }]);
            break;
        }
      },
    });
  }
  /**
   * * Open iDelibe in a new Tab with courrier id send
   * @params no params
   */
  openPointInIdelibe(): void {
    console.log(this.amountOfFiles)
    if (this.amountOfFiles > 0) {
      this.confirmService.confirm({
        header: `${this.amountOfFiles} fichier(s) détecté(s)`,
        key: 'courrierFicheForm',
        message: 'Voulez-vous dupliquer les fichiers de la fiche courrier dans le point?',
        accept: () => {
          window.open(environment.iDelibeUrl + '/private/points/form?mode=create&mailId=' + this.courrier.id + '&importFiles=true');
        },
        reject: (e) => {
          if (e === 1) {
            return window.open(environment.iDelibeUrl + '/private/points/form?mode=create&mailId=' + this.courrier.id + '&importFiles=false');
          }
          if (e === 2) {
            return false;
          }
        },
      });
    } else {
      window.open(environment.iDelibeUrl + '/private/points/form?mode=create&mailId=' + this.courrier.id + '&importFiles=false');
    }
  }

  receive_tabsXL(event): void {
    this.mailTabActiveXL = event?.id ?? 'infos';
    localStorage.setItem('openedCourrierTabXL', this.mailTabActiveXL);
  }

  onFileDropped(ev: AreaDropEvent): void {
    this.uploadedFilesFromDragAndDrop = Array.from(ev.files);
  }
  onDragOver(): void {
    this.isFileOverComponent = true;
  }

  onDragLeave(): void {
    setTimeout(() => {
      this.isFileOverComponent = false;
    }, 5000);
  }

  switchFile(value: number): void {
    this.forceSwitchFile = [];
    this.forceSwitchFile = [value];
  }

  addTags(tagsToAdd): void {
    if (tagsToAdd.length > 0) {
      this.multipleStatutesService.postMailMultipleStatus(this.courrier.id, tagsToAdd.join(',')).subscribe({
        next: () => {
          this.toastr.success(this.translater.translate('tagsInfos.labelAddedSuccessfully'));
          this.getTagsByMail(this.courrier);
        },
        error: (error) => {
          if (error && error.status === 403) {
            this.toastr.success(this.translater.translate('tagsInfos.cannotAddLabels'));
          }
        },
      });
    } else {
      this.toastr.error(this.translater.translate('tagsInfos.pleaseSelectATag'));
    }
  }

  /**
   * method move a tags of the current courrier
   * Ask confirmation before to delete it
   * Call getTagsByMail toretreive the correct list of tags linked with the current courrier
   * @param event tags To delete
   */
  deleteTags(event): void {
    const ref = this.dialogService.open(GuardConfirmModalComponent, {
      header: this.translater.translate('modals.confirmation'),
      styleClass: 'super-compos-modal-content confirm-inforius',
      dismissableMask: false,
      width: '30em',
      baseZIndex: 1000,
      data: {
        message: this.translater.translate('tagsInfos.unlinkLabelConfirmation'),
      },
    });
    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          const selectedTags = [];
          selectedTags.push(event);

          if (selectedTags.length > 0) {
            selectedTags.map((toDelete) => {
              this.multipleStatutesService.deleteMailMultipleStatutes(toDelete.mailId, toDelete.id).subscribe({
                next: () => {
                  this.toastr.success(this.translater.translate('tagsInfos.successTagDeletedFromMail'));
                  this.getTagsByMail(this.courrier);
                },
                error: () => {
                  this.toastr.error(this.translater.translate('tagsInfos.cannotDeleteLabels'));
                },
              });
            });
          }
        } else {
          this.tagsCourrier = [...this.tagsCourrier];
        }
      },
    });
  }

  createTag(): void {
    const ref = this.dialogService.open(CreateNewTagComponent, {
      header: this.translater.translate('tagsInfos.createATag'),
      styleClass: 'super-compos-modal-content',
      showHeader: true,
      width: '50vw',
      dismissableMask: false,
      closable: false,
      data: {
        serviceParent: this.serviceList,
        flattenedServices: this.servicesChildParent,
      },
    });
    ref.onClose.subscribe({
      next: (value: MultipleStatutesDTO) => {
        //une fois créée, on va l'ajouter à la liste des tags afin que la liste des ajoutables soit update (Si et seulement si la nouvelle étiquette passe les droits évidemment)
        this.tags.push({
          label: value.description,
          value: value.id,
          textColor: value.color !== null && value.color !== 'Pas de couleur' ? this.getOppositeColor(value.color) : '#000000',
          color: value.color,
          notUsed: value.notUsed,
          cocherAjouterDroitAccesGroupeID: value.cocherAjouterDroitAccesGroupeID,
          courrierActionDroitCocherGroupeID: value.courrierActionDroitCocherGroupeID,
          courrierActionDroitDecocherGroupeID: value.courrierActionDroitDecocherGroupeID,
          ordreAffichage: value.ordreAffichage,
          servicesAuthorized: value.servicesAuthorized,
          isNewlyCreated: true,
        });
        this.tags = [...this.tags];
      },
    });
  }
  currentStepValidationTranslation(validationEtape: number, validationEtapeMax: number, validationUsers: string): string {
    return this.translater.translate('courrierFiche.currentStepValidation', {
      validationEtape: validationEtape,
      validationEtapeMax: validationEtapeMax,
      validationUsers: validationUsers,
    });
  }

  receiveUploadedFilesAreSaved(): void {
    this.uploadedFilesFromDragAndDrop = null;
  }
  onNativeDrop(event: DragEvent): void {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files?.length) {
      this.uploadedFilesFromDragAndDrop = [];
      setTimeout(() => {
        this.uploadedFilesFromDragAndDrop = Array.from(files);
      });
    }
  }
}
